import { Button, message, Popover, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import {
  AiOutlineException,
  AiOutlineCheckCircle,
  AiOutlineExclamationCircle,
  AiOutlineMinusCircle,
} from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { paymentVoucherActions } from "../../../../config/actions/finance/paymentVouchers/paymentVouchers.actions";
import generatePDF from "../../../../config/services/generatePdf";
import tableButtonActions from "../../../shared/Tables/TableButtonActions";
import TableTitle from "../../../shared/Tables/TableTitle";
import appConfig from "../../../../config/config.json";
import { map, uniqBy } from "lodash";

const PaymentVouchersTable = ({
  handleDelete,
  handleRefreshTable,
  handleExportRecords,
  handleOpenAddModal,
  handleViewDetails,
  handOpenEditModal,
}) => {
  //state,variable, decalrations and initialization
  const [deleteId, setDeleteId] = useState("");
  const [filterTable, setfilterTable] = useState(null);
  const {
    deletePaymentVouchersLoading: deleteLoading,
    deletePaymentVouchersSuccess: deleteSuccess,
    deletePaymentVouchersError: deleteError,
    deletePaymentVouchersMessage: deleteMessage,
    paymentVouchers: data,
    paymentVouchersLoading: loading,
    paymentVouchersSuccess: success,
    paymentVouchersError: error,
  } = useSelector((state) => state.paymentVouchersState);
  const {
    success: logDetailsSuccess,
    error: logDetailsError,
    records,
  } = useSelector((state) => state.logDetailsState.addLogDetails);
  const dispatch = useDispatch();

  const budgetLines = map(uniqBy(data, "budgetLine"), (budgetLine) => ({
    text: budgetLine.budgetLine,
    value: budgetLine.budgetLine,
  }));
  const requisitions = map(uniqBy(data, "memo_number"), (memo) => ({
    text: memo.memo_number,
    value: memo.memo_number,
  }));
  const projects = map(uniqBy(data, "project"), (memo) => ({
    text: memo.project,
    value: memo.project,
  }));
  const statuses = [
    {
      text: "Pending",
      value: "pending",
    },
    {
      text: "Checked",
      value: "checked",
    },
    {
      text: "Approved",
      value: "approved",
    },
    {
      text: "Rejected",
      value: "rejected",
    },
  ];
  const columns = [
    {
      title: "Funds Advance/Withdraw Form",
      key: "id",
      render: (text) => (
        <div>
          <span className="d-md-none">Funds Advance/Withdraw Form:</span>{" "}
          {text.id} <br />
          <div className="d-md-none">
            Requisition Form: {text.memo_number} <br />
            Budget Line: {text.budgetLine} <br />
            Project: {text.project} <br />
            <br />
            <Popover
              className=""
              trigger="click"
              placement="bottom"
              content={() =>
                tableButtonActions(text, {
                  viewDetails,
                  updateRecord,
                  confirmDelete,
                  deleteRecord,
                  deleteLoading,
                  deleteId,
                })
              }
            >
              Actions: <Button type="link">Actions</Button>
            </Popover>
          </div>
        </div>
      ),
    },
    {
      title: "Requisition Form Number",
      dataIndex: "memo_number",
      key: "start_date",
      responsive: ["md"],
      filters: requisitions,
      filterSearch: true,
      onFilter: (value, record) => record?.memo_number === value,
    },
    {
      title: "Budget Line",
      dataIndex: "budgetLine",
      key: "budgetLine",
      responsive: ["md"],
      filters: budgetLines,
      filterSearch: true,
      onFilter: (value, record) => record?.budgetLine === value,
    },
    {
      title: "Project",
      dataIndex: "project",
      key: "project",
      responsive: ["md"],
      filters: projects,
      filterSearch: true,
      onFilter: (value, record) => record?.project === value,
    },
    {
      title: "Action",
      key: "operation",
      render: (text) => (
        <Popover
          trigger="click"
          placement="bottom"
          content={() =>
            tableButtonActions(text, {
              viewDetails,
              updateRecord,
              confirmDelete,
              deleteRecord,
              deleteLoading,
              deleteId,
            })
          }
        >
          <Button>Actions</Button>
        </Popover>
      ),
      responsive: ["md"],
    },
  ];
  /** functions */
  const deleteRecord = (e) => setDeleteId(e.target.id);
  const confirmDelete = () => {
    const paymentVouchers = data.filter((e) => e.id !== deleteId);
    handleDelete(deleteId, paymentVouchers);
  };
  const refreshTable = () => {
    handleRefreshTable();
    if (!success && error) message.error(error);
  };
  const viewDetails = (e) => {
    handleViewDetails(e.target.id);
  };
  const search = (value) => {
    const filterTable = data.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.toLowerCase())
      )
    );
    setfilterTable(filterTable);
  };
  const setfilterTableNull = (e) => {
    if (!e.target.value) setfilterTable(null);
  };

  const showTotal = (total) => `Total: ${total}`;
  const updateRecord = (e) => {
    handOpenEditModal(true);
    const paymentVouchers = data.filter((pv) => pv.id === e.target.id);
    dispatch(paymentVoucherActions.editPaymentVouchersData(paymentVouchers[0]));
  };
  const openAddModal = () => handleOpenAddModal(true);
  const exportRecords = () => {
    message.loading("Proccessing document for export please wait ", 3);
    handleExportRecords();
  };
  const generateRecordsPdf = () => {
    const pdfColumns = [
      "Funds Advance/Withdraw Form Number",
      "Requisition Form Number",
      "Project",
      "Status",
    ];
    let pdfRows = [];
    data?.forEach((record) => {
      const row = [
        record.id,
        record.memo_number,
        record.project,
        record.status.toUpperCase(),
      ];
      pdfRows.push(row);
    });
    generatePDF(
      pdfRows,
      pdfColumns,
      `Amani Intiative Funds Advance/Withdraw Forms - ${new Date().toLocaleDateString()}`,
      "Amani Intiatice Funds Advance/Withdraw Forms.pdf"
    );
  };
  /** use Effect */
  useEffect(() => {
    if (logDetailsSuccess && records === "paymentVouchers") {
      message.info("Started download");
      generateRecordsPdf();
    } else if (!logDetailsSuccess && logDetailsError)
      message.error(logDetailsError);
    if (deleteSuccess && deleteMessage) message.success(deleteMessage);
    else if (!deleteSuccess && deleteError) message.error(deleteError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    logDetailsSuccess,
    logDetailsError,
    deleteSuccess,
    deleteMessage,
    deleteError,
  ]);

  return (
    <div>
      <Table
        pagination={{ total: data.length, showSizeChanger: true, showTotal }}
        loading={loading}
        title={() =>
          TableTitle({
            search,
            setfilterTableNull,
            refreshTable,
            exportRecords,
            openAddModal,
          })
        }
        bordered={true}
        dataSource={filterTable === null ? data : filterTable}
        columns={columns}
      />
    </div>
  );
};

export default PaymentVouchersTable;
